export default {
  status: {
    pending: 'Oczekiwanie na DNS',
    verified: 'Aktywna',
    failed: 'Wymagane działanie',
  },
  summary: {
    preparing:
      'Rekordy dla {{host}} są przygotowywane. Pojawią się tutaj w ciągu około 15 minut — albo od razu po kliknięciu Sprawdź ponownie.',
    pending:
      'Oczekiwanie na poniższe rekordy DNS. Zwykle trwa to kilka minut, a może potrwać do 48 godzin — sprawdzamy dalej automatycznie.',
    certificate_pending: 'Rekordy są na miejscu. Certyfikat dla {{host}} jest wystawiany — zwykle trwa to kilka minut.',
    verified: 'Sklep internetowy działa pod adresem {{host}}.',
    serving: 'Sklep internetowy działa pod adresem {{serving_host}}, ale sam adres {{host}} jeszcze go nie otwiera.',
    apex_elsewhere:
      'Rekord A dla @ nie wskazuje jeszcze na sklep. Jeśli {{host}} wyświetla stronę internetową, która ma tam zostać, należy zostawić @ bez zmian — sklep działa pod adresem {{serving_host}}. W przeciwnym razie należy dodać poniższy rekord A.',
    apex_held:
      '{{host}} jest używana przez inną stronę internetową w Vercel. Aby {{host}} również otwierała sklep, należy najpierw usunąć domenę z tamtej strony.',
    regressed:
      '{{host}} wcześniej działała, ale jeden z poniższych rekordów przestał być potwierdzany. Należy poprawić go u dostawcy DNS, a następnie kliknąć Sprawdź ponownie.',
    record_elsewhere:
      'Jeden z poniższych rekordów wskazuje w inne miejsce. Należy zmienić go u dostawcy DNS na wyświetloną wartość, a następnie kliknąć Sprawdź ponownie.',
    records_missing:
      'Po 48 godzinach nadal nie znaleziono poniższych rekordów. Należy sprawdzić, czy zapisano je dla {{zone}} u dostawcy, który zarządza jej DNS. Jeśli ten dostawca nie pozwala na zmianę, domena może być u niego zablokowana.',
    certificate: {
      ownership_proof_required:
        '{{host}} jest też połączona z innym kontem Vercel, więc restauracja musi potwierdzić, że domena należy do niej.',
      held_by_another_project:
        '{{host}} jest nadal używana przez inną stronę internetową w Vercel, więc sklep nie może jej jeszcze używać.',
      dns_correct_but_unconfigured: 'Rekordy są poprawne, ale coś innego w {{host}} blokuje certyfikat.',
      name_mismatch: '{{host}} nadal odpowiada certyfikatem dla innej nazwy.',
      expired: 'Certyfikat dla {{host}} wygasł. Otrzymaliśmy powiadomienie i zajmujemy się tym.',
      expiring: 'Certyfikat dla {{host}} wkrótce wygaśnie i nie został jeszcze odnowiony. Zajmujemy się tym.',
      attach_refused:
        'Nasz dostawca hostingu odmówił dodania {{host}} po naszej stronie. Zostaliśmy powiadomieni i zajmujemy się tym.',
      overdue: 'Certyfikat dla {{host}} nadal nie został wystawiony po 48 godzinach.',
      unknown: 'Nie udało się wystawić certyfikatu dla {{host}}.',
    },
    certificate_see_row: 'Wiersz certyfikatu poniżej wskazuje, co należy zrobić.',
  },
  instructions: {
    title: 'Jak połączyć {{host}}',
    step_provider:
      'Należy zalogować się tam, gdzie zarządzany jest DNS domeny {{zone}} — zwykle w firmie, w której kupiono domenę.',
    step_add: 'Należy dodać każdy z poniższych rekordów dokładnie tak, jak pokazano: typ, nazwę i wartość.',
    step_check: 'Po zapisaniu należy kliknąć {{button}}. Sprawdzamy też dalej automatycznie.',
    tip_name:
      'Większość dostawców oczekuje w polu nazwy tylko części przed {{zone}} — tutaj {{names}}. Pełna nazwa jest też podana, dla dostawców, którzy jej wymagają.',
    tip_apex: '@ oznacza samą domenę {{zone}}. Niektórzy dostawcy zamiast tego zostawiają pustą nazwę.',
    tip_apex_website:
      'Jeśli {{zone}} otwiera już stronę internetową, skierowanie @ na sklep odbierze {{zone}} tej stronie. Aby strona pozostała pod tym adresem, należy zostawić rekordy dla @ bez zmian — sklep nadal działa pod adresem www.{{zone}} — albo zamiast tego połączyć ze sklepem subdomenę, np. order.{{zone}}.',
    tip_existing:
      'Należy usunąć wszystkie inne rekordy A, AAAA lub CNAME dla {{name}}. Dwa rekordy wskazujące różne miejsca sprawiają, że sklep ładuje się tylko czasami.',
    tip_cloudflare:
      'W Cloudflare należy ustawić te rekordy na Tylko DNS (szara chmurka). Przy włączonym proxy nikt nie widzi, dokąd wskazują, i nie da się wystawić certyfikatu.',
    tip_locked:
      'Jeśli dostawca nie pozwala dodać ani zmienić tych rekordów, domena może być zablokowana albo jej DNS jest zarządzany gdzie indziej. Dostawca może ją odblokować lub wskazać, gdzie zarządzany jest DNS.',
  },
  records: {
    title: 'Rekordy dla {{host}}',
  },
  separate_domains: {
    apex: 'Ta domena jest tylko dla sklepu internetowego: sklep zajmuje {{zone}} i www.{{zone}}. Strona internetowa potrzebuje innej nazwy — subdomeny {{zone}} albo własnej domeny.',
    subdomain:
      'Ta domena jest tylko dla sklepu internetowego. Strona internetowa może używać {{zone}} lub www.{{zone}}.',
  },
  load_error: 'Nie udało się wczytać stanu domeny.',
  no_access: 'Brak dostępu do stanu domeny tej restauracji.',
  polling_stopped: 'Ta strona przestała się sama odświeżać. Aby ją odświeżyć, należy kliknąć Sprawdź ponownie.',
  buttons: {
    check_again: 'Sprawdź ponownie',
    retry: 'Spróbuj ponownie',
  },
  toasts: {
    check_started: 'Sprawdzamy rekordy. Może to potrwać minutę.',
    check_failed: 'Nie udało się rozpocząć sprawdzania. Należy spróbować ponownie.',
    check_too_soon: 'Właśnie sprawdzono. Przed kolejnym sprawdzeniem należy odczekać minutę.',
  },
};
